export default __webpack_public_path__ + "static/O0137-1bce9eb713618167e7464f338af4cfeb.png";